import { createEntityAdapter } from "@reduxjs/toolkit";
import { createAppSlice } from "../../../lib/store/createAppSlice.js";
import { PerxisService } from "../../../services/perxis/index.js";
import { name } from "../config/name.js";
const adapter = createEntityAdapter();
const initialState = {
  ...adapter.getInitialState(),
  forCollectionEntry: {}
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: (create) => ({
    addMarketingInfo: create.reducer((state, action) => {
      adapter.addOne(state, action.payload);
    }),
    addManyMarketingInfo: create.reducer((state, action) => {
      adapter.addMany(state, action.payload);
    }),
    removeMarketingInfo: create.reducer((state, action) => {
      adapter.removeOne(state, action.payload);
    }),
    removeManyMarketingInfo: create.reducer((state, action) => {
      adapter.removeMany(state, action.payload);
    }),
    setForCollectionEntry: create.reducer((state, { payload }) => {
      state.forCollectionEntry = payload;
    }),
    fetchMarketingInfo: create.asyncThunk(async (parameters) => {
      const { itemsClient } = PerxisService.getInstance();
      const response = await itemsClient.findPublished({
        ...parameters
      });
      const { items } = response;
      return items;
    })
  })
});
const { reducer, actions, reducerPath } = slice;
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice
};
